module.exports = __webpack_public_path__ + "static/media/1.8acc7b82.jpg";